"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _default = exports.default = {
  props: ['buffer', 'message'],
  data() {
    return {
      requestingInput: false,
      pluginUiSections: _GlobalApi.default.singleton().messageInfoPlugins
    };
  },
  computed: {
    showLinkPreviews() {
      return this.$state.setting('buffers.show_link_previews');
    }
  },
  methods: {
    urlPreview(url) {
      this.$state.$emit('mediaviewer.show', url);
    },
    areWeAnOp() {
      let ourNick = this.buffer.getNetwork().nick;
      return this.buffer.isUserAnOp(ourNick);
    },
    isSelf() {
      let user = this.$state.getUser(this.buffer.getNetwork().id, this.message.nick);
      return user && this.buffer.getNetwork().ircClient.user.nick === user.nick;
    },
    onBan() {
      this.buffer.banUser(this.message.user);
    },
    onKick(reason) {
      this.buffer.kickUser(this.message.user, reason);
    },
    openQuery() {
      let network = this.buffer.getNetwork();
      let buffer = this.$state.addBuffer(network.id, this.message.nick);
      this.$state.setActiveBuffer(network.id, buffer.name);
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["MessageInfo"]
window._app_exports.components.MessageInfo = exports.default ? exports.default : exports;
